import { View, ViewModel } from "binder"
import { FormBuilderElement } from "src/formBuilder/structure/element";
import { PropertiesPanelViewModel } from "./propertiesPanel/propertiesPanel-viewModel";
import { ComponentsList, TemplateEditorViewModel } from "./templateEditor-viewModel"

export class TemplateEditorView extends View<TemplateEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-18FFD9C5-E569-47A1-897F-7D933A5A6F71"
    }
    loadHtml(): string {
        let element = require('./templateEditor.html').default;
        let style = require('./templateEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set componentsList(v: ComponentsList) { this._componentsList = v; } public get componentsList(): ComponentsList { return this._componentsList;} private _componentsList: ComponentsList;
    public set propertiesPanel(v: PropertiesPanelViewModel) { this._propertiesPanel = v; } public get propertiesPanel(): PropertiesPanelViewModel { return this._propertiesPanel;} private _propertiesPanel: PropertiesPanelViewModel;
    public set rootElement(v: FormBuilderElement) { this._rootElement = v; } public get rootElement(): FormBuilderElement { return this._rootElement;} private _rootElement: FormBuilderElement;
    public set selectedElement(v: FormBuilderElement) { this._selectedElement = v; } public get selectedElement(): FormBuilderElement { return this._selectedElement;} private _selectedElement: FormBuilderElement;
    public set currentPart(v: ViewModel) { this._currentPart = v; } public get currentPart(): ViewModel { return this._currentPart;} private _currentPart: ViewModel;
    
    
    selectComponents(){
        this.dataContext.selectComponents();
    }
    selectProperties(){
        this.dataContext.selectProperties();
    }
    selectStructure(){
        this.dataContext.selectStructure();        
    }
    confirm(){
        this.dataContext.confirm();
    }
    import(){
        this.dataContext.import();
    }
    export(){
        this.dataContext.export();
    }
}
